export default __webpack_public_path__ + "static/media/rocket_anim_3.af50ceb2.png";